// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VModal from 'vue-js-modal'
import VCalendar from 'v-calendar'
import App from './App'
import router from './router'
import i18n from './i18n/i18n'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import HighchartsVue from 'highcharts-vue'
import More from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'
import Stock from 'highcharts/modules/stock'
import Draggable from 'highcharts/modules/draggable-points'
import loadExporting from 'highcharts/modules/exporting'
import boost from 'highcharts/modules/boost'
import noData from 'highcharts/modules/no-data-to-display'
import PossSpinner from './components/POSSSpinner'
import xrange from 'highcharts/modules/xrange'

import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
Vue.component('p-spinner', PossSpinner)

More(Highcharts)
Draggable(Highcharts)
loadExporting(Highcharts)
boost(Highcharts)
Stock(Highcharts)
noData(Highcharts)
xrange(Highcharts)

Vue.use(HighchartsVue, { Highcharts })
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VModal, {
  componentName: 'Modal',
  dialog: true
})
Vue.use(VCalendar, {})

Vue.config.productionTip = false
require('./styles/spinner.css')

/* eslint-disable no-new */
Vue.prototype.$eventHub = new Vue()

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js